import { type KPIScoreLimit, Score } from 'components/KPICard'

export const DEAD_END_CHATS_RANGE_DESCRIPTION = `Needs work = greater than 20%
Fair = 10% - 19%
Good = 5% - 9%
Excellent = less than 5%`

export const KPI_SCORES: KPIScoreLimit[] = [
  { min: 20, score: Score.NeedsWork },
  { min: 10, score: Score.Fair },
  { min: 10, score: Score.Good },
  { min: 0, score: Score.Excellent },
]
